import api from 'api'
import { CACHE_TAG_CALLS_LIST } from '../cacheTagTypes'
import { withIdTag } from 'utils/cache'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    getCustomerCallById: build.query({
      query: body => ({ url: '/api/account/call/view', method: 'POST', body }),
      providesTags: (result, error, arg) => withIdTag(CACHE_TAG_CALLS_LIST, arg?.id),
    }),
  }),
})

export const { useLazyGetCustomerCallByIdQuery } = extendedApi
